var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css, LitElement, nothing } from "lit";
import { property } from "lit/decorators.js";
import { FormControlMixin } from "../../../a2k-form-control/index.js";
export class A2kButton extends FormControlMixin(LitElement) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.type = "";
        this.size = "medium";
    }
    handleSubmit() {
        this.form.requestSubmit();
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.type && this.form) {
            this.type === "submit";
        }
        else {
            this.type === "button";
        }
        // This is due to the Submit event crossing the shadow DOM's boundaries
        if (this.type === "submit") {
            this.addEventListener("click", this.handleSubmit);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.handleSubmit);
    }
    render() {
        return html ` <button
      data-size="${this.size}"
      aria-label="${this.ariaLabel || nothing}"
      ?disabled=${this.disabled}
    >
      <slot></slot>
    </button>`;
    }
}
A2kButton.styles = css `
    :host {
      width: fit-content;
    }

    :host([disabled]) {
      pointer-events: none;
      cursor: not-allowed;
    }

    button {
      background-color: var(--button-color-background);
      color: (--button-font-color);
      font-family: var(--button-font-family);
      padding: var(--button-padding);
      font-weight: var(--button-font-weight);
      box-sizing: border-box;
      box-shadow: var(--button-shadow);
      border-width: var(--button-border-width);
      border-color: var(--button-border-color);
      border-style: var(--button-border-style);
      outline-color: var(--outline-color-focus);
      outline-offset: var(--outline-offset-focus);
      cursor: var(--cursor-pointer);
      display: inline-block;
      border: var(--button-border);
      border-left: 1px dotted var(--color-white);
      border-top: 1px dotted var(--color-white);
      box-shadow: var(--button-shadow);
    }

    button[data-size="small"] {
      padding: var(--button-padding-small);
      box-shadow: var(--button-small-shadow);
    }

    button[data-size="large"] {
      padding: var(--button-padding-large);
      font-size: var(--button-font-size-large);
    }

    button:not([disabled]):active {
      border-bottom: 2px solid transparent;
      border-right: 0;
      border-left: 1px dotted var(--color-black);
      border-top: 1px dotted var(--color-black);
      box-shadow: var(--button-shadow-active);
      transform: translate(2px, 2px);
    }

    button[data-size="small"]:not([disabled]):active {
      box-shadow: var(--button-small-shadow-active);
      transform: translate(0px, 1px);
    }
  `;
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], A2kButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], A2kButton.prototype, "type", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], A2kButton.prototype, "size", void 0);
